import script from "./CardBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBlock.vue?vue&type=script&setup=true&lang=js"

import "./CardBlock.vue?vue&type=style&index=0&id=d7288a30&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7288a30"]])

export default __exports__